module.exports = __webpack_public_path__ + "img/dropsLive_900.b4fad82d.png";